export const Terms = () => {
    return (
        <section className="py-24 lg:py-32 bg-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 mb-4 block font-display">
                    Legal
                </span>

                <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
                    Terms & Conditions
                </h1>

                <p className="mt-6 text-base lg:text-lg leading-relaxed text-slate-600">
                    These Terms & Conditions govern your use of the NextGen
                    Systems website and services. By accessing this website,
                    you agree to comply with these terms.
                </p>

                <div className="mt-12 space-y-10">
                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Use of Services
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            You agree to use our services only for lawful
                            purposes and in a manner that does not infringe
                            the rights of others or restrict their use.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Intellectual Property
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            All content, branding, and materials on this website
                            are the property of NextGen Systems and may not be
                            reproduced without permission.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Limitation of Liability
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            We are not liable for any indirect or consequential
                            damages arising from the use of our website or
                            services.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-slate-900">
                            Modifications
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            We reserve the right to modify these terms at any
                            time. Continued use of the website implies acceptance
                            of the updated terms.
                        </p>
                    </div>

                    <div className="border-t pt-8">
                        <h2 className="text-xl font-semibold text-slate-900">
                            Contact
                        </h2>
                        <p className="mt-3 text-slate-600 leading-relaxed">
                            For any questions regarding these terms, please reach
                            out via official channels listed on this website.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};